//Built-in libraries

//Third party libraries

import Button from '@/components/UI/Button';
//Custom components
import { HookInput } from '@/components/UI/HookForm/Form/Input';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function DevelopmentSchedule() {
  const { setCurrentStep } = useApplicationFormContext();

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>Anticipated Development Schedule</h3>
        <div className='py-4'>
          <h3 className='font-medium'>Acquisition</h3>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput customClassName='col-span-2' label='Start Date' name='developmentSchedule.schedule1.startDate' type='date' />
            <HookInput customClassName='col-span-2' label='Finish Date' name='developmentSchedule.schedule1.finishDate' type='date' />
          </div>
        </div>
        <div className='py-4'>
          <h3 className='font-medium'>Financial Close</h3>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput customClassName='col-span-2' label='Start Date' name='developmentSchedule.schedule2.startDate' type='date' />
            <HookInput customClassName='col-span-2' label='Finish Date' name='developmentSchedule.schedule2.finishDate' type='date' />
          </div>
        </div>
        <div className='py-4'>
          <h3 className='font-medium'>Construction</h3>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput customClassName='col-span-2' label='Start Date' name='developmentSchedule.schedule3.startDate' type='date' />
            <HookInput customClassName='col-span-2' label='Finish Date' name='developmentSchedule.schedule3.finishDate' type='date' />
          </div>
        </div>
        <div className='py-4'>
          <h3 className='font-medium'>Lease Up</h3>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput customClassName='col-span-2' label='Start Date' name='developmentSchedule.schedule4.startDate' type='date' />
            <HookInput customClassName='col-span-2' label='Finish Date' name='developmentSchedule.schedule4.finishDate' type='date' />
          </div>
        </div>
        <div className='py-4'>
          <h3 className='font-medium'>Exit</h3>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput customClassName='col-span-2' label='Start Date' name='developmentSchedule.schedule5.startDate' type='date' />
            <HookInput customClassName='col-span-2' label='Finish Date' name='developmentSchedule.schedule5.finishDate' type='date' />
          </div>
        </div>
        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
          <Button label='Next' btnStyle='primary' type='submit' />
        </div>
      </div>
    </div>
  );
}
